import React from 'react';
import ReactDOM from 'react-dom';
import MaterialAdmin from './materialAdmin';
import registerServiceWorker, { unregister } from './registerServiceWorker';

window.application = {
  app: 'landlords',
  env: process.env.REACT_APP_ENV === 'prod' ? 'prod' : 'stage'
}

ReactDOM.render(<MaterialAdmin />, document.getElementById('root'));

// Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./materialAdmin.js', () => {
    const NextApp = require('./materialAdmin').default;
    ReactDOM.render(<NextApp />, document.getElementById('root'));
  });
}
unregister();



// WEBPACK FOOTER //
// ./src/index.js